<template>
  <v-row
    v-if="$route.fullPath === '/admin'"
    justify="center"
    align="center"
    class="fill-height"
  >
    <v-col>
      <v-row justify="center" align="center">
        <v-col cols="6" md="4">
          <h2>Välkommen till administratörssidan</h2>
          <p>
            Här kan ni skapa nya bedömningsverktyg, lägga till nya språk,
            korrigera i upplagda bedömningar och söka bland användare
          </p>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="3" md="4">
          <v-btn
            v-for="button in buttons"
            :key="button.uid"
            class="mr-5"
            :to="button.to"
            color="primary"
            >{{ button.text }}</v-btn
          >
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <v-row v-else justify="center" class="fill-height">
    <v-col>
      <router-view></router-view>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Admin",
  props: {},
  data() {
    return {
      buttons: [
        { uid: "afsdf", text: "Bedömningar", to: "admin/firebase-login" },
        { uid: "f,mds", text: "Användare", to: "admin/search" }
      ]
    };
  },
  computed: {}
};
</script>

<style></style>
